<template>
  <div class="patient-list">
    <div class="mt-3 mb-0 w-100 d-flex flex-row justify-content-between">
      <div class="d-flex align-items-center">
        <div class="">
          <a
            class="hover-pointer"
            style="font-size: 14px"
            @click="showReportRequestsModal = true"
          >
            <i class="fa fa-download"></i>
            <span class="ml-2 text-primary" style="font-size: 14px"
              >Export</span
            >
          </a>
        </div>
        <div class="ml-2" style="min-width:300px; width: max-content;">
          <v-select
            :options="timeZoneOptions"
            v-model="timeZoneSelected"
            :clearable="false"
          />
        </div>
      </div>

      <div class="d-flex flex-row justify-content-end align-items-center">
        <top-paginator
          :total="listTotal"
          :page="page"
          :perPage="pageSize"
          @change-page="changePage"
        />
      </div>
    </div>
    <div class="grid-container mt-10">
      <grid
        ref="grid"
        :groupFeature="false"
        :autoHeight="true"
        :columns="columns"
        :data="items"
        :store="gridConfig.store"
        :selectionMode="gridConfig.selectionMode"
        :columnLines="gridConfig.columnLines"
        :searchFeature="true"
        @storesort="gridListeners.storeSort"
        :stripeFeature="true"
      ></grid>
    </div>
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="AuditRecords"
    />
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import TopPaginator from "../controls/TopPaginator.vue";
import {
  changeTimeZoneOptions,
  getTimeZoneOptions,
  getTimeZoneDefault
} from "../../helpers/date";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";

export default {
  name: "AuditAuthListView",
  components: { Grid, TopPaginator, ReportRequestIndex },
  props: [
    "showing",
    "list",
    "listTotal",
    "exportFilter",
    "orderBy",
    "orderByDescending",
    "page",
    "pageSize"
  ],
  data() {
    const self = this;
    return {
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: false,
          checkbox: false,
          rowCheckboxSelection: false,
          showCheckAll: false
        },
        columnLines: false,
        store: {
          sorters: [
            {
              field: this.orderBy,
              ascending: !this.orderByDescending
            }
          ],
          remoteSort: true
        }
      },
      gridListeners: {
        storeSort: sortData => {
          this.store = sortData.source;
          if (sortData.sorters.length === 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.$emit("change-order", {
              orderBy: field,
              orderByDescending: !ascending
            });
          }
        }
      },
      lastTimeout: null,
      firstShowing: true,
      store: null,
      showReportRequestsModal: false,
      timeZoneOptions: [],
      timeZoneSelected: null
    };
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    changePage(page) {
      this.$emit("change-page", {
        ...this.pagination,
        page
      });
    },
    initializeData() {
      this.timeZoneOptions = getTimeZoneOptions();
      this.timeZoneSelected = this.timeZoneOptions.find(
        x => x.value == getTimeZoneDefault()
      );
    }
  },
  computed: {
    items() {
      return this.list;
    },
    columns() {
      this.timeZoneSelected;
      return [
        {
          text: "Date & Time",
          field: "datetime",
          type: "template",
          width: 160,
          editor: false,
          template: ({ record }) => {
            return changeTimeZoneOptions(
              record.data.dateTime,
              this.timeZoneSelected
            );
          }
        },
        {
          text: "User",
          field: "user",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => {
            return record.data.userName;
          }
        },
        {
          text: "IP Address",
          field: "ipAddress",
          type: "template",
          width: 100,
          editor: false,
          template: ({ record }) => {
            return record.data.ipAddress;
          },
          sortable: false
        },
        {
          text: "Event",
          field: "event",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => {
            return record.data.event;
          },
          sortable: false
        },
        {
          text: "Details",
          field: "details",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => {
            return record.data.details;
          },
          sortable: false
        }
      ];
    }
  }
};
</script>

<style scoped>
.filter-select {
  height: 50px;
  width: 300px;
  padding-top: 5px;
}
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  min-width: 250px;
}
.client-card {
  min-width: 180px;
  max-width: 180px;
  height: 315px;
}
.little-circle {
  width: 10px;
  height: 10px;
}
.little-circle-exclamation {
  width: 20px;
  height: 20px;
}
.little-circle-exclamation-container {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.client-avatar {
  width: 100px;
  height: 100px;
  text-align: center;
}
.client-data {
  font-size: 0.8rem;
  word-break: break-all;
  overflow: hidden;
  text-overflow: clip;
}
.client-card:hover {
  cursor: pointer;
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  transform: translateY(-3px);
  transition-duration: 0.3s;
  transition-property: transform;
}
.clients-list {
  height: calc(100vh - 264px - var(--filter-height));
  overflow-y: auto;
}
.border-yellow {
  border-color: #ffc107 !important;
}
.bg-yellow {
  background-color: #ffc107 !important;
}
.client-text-data {
  height: 180px;
}
.client-eoc-data {
  height: 119px;
}
.filter-values {
  width: 250px;
}
.filter-value {
  position: relative;
  min-width: 100px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-values {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filters-container {
  overflow-x: auto;
}
.separator-or {
  margin-bottom: -13px;
}
div.disabled {
  pointer-events: none;

  /* for "disabled" effect */
  opacity: 0.5;
  background: #ccc;
}
.max-2-lines {
  max-height: 38px;
}
.tooltip-icon-bg {
  top: 5px;
  left: 5px;
  width: 10px;
  height: 13px;
  z-index: 1;
}
.patient-list >>> .b-grid-container .b-container {
  max-height: calc(100vh - 290px - var(--filter-height));
}
</style>

<style>
.filter-select .vs__dropdown-toggle {
  height: 100%;
  border-radius: 0;
  border: 0;
}

.patient-badge {
  color: white;
  font-size: 11px;
  width: 40px;
  height: 16px;
  text-align: center;
  border-radius: 25px;
  line-height: 1.5;
}
.patient-picker-hide-options .vs__dropdown-menu {
  display: none;
}
.patient-picker-hide-options.vs--open .vs__dropdown-toggle {
  border-bottom-color: #0084ff !important;
  border-bottom-width: 2px;
}
.patient-list .grid-container .b-grid-container {
  display: flex;
  width: 100%;
  height: 100% !important;
  flex: 1;
}
.patient-list .grid-container .b-grid {
  max-height: 100%;
  width: 100%;
}
.mt-10 {
  margin-top: 10px;
}
</style>
